export const SLICE_SIZE = 4 * 1024 * 1024
export const MAX_THREAD_COUNT = 5
export const API_PREFIX = '/node/ajax'
export const UPLOAD_TYPES = {
    LOCAL_UPLOAD: 'LOCAL_UPLOAD',
    INPUT_LINK: 'INPUT_LINK',
    UPLOAD_LINK_CSV: 'UPLOAD_LINK_CSV',
}
export const UPLOAD_STATUS = {
    WAIT: 0,
    UPLOADING: 1,
    DONE: 2,
    FAIL: 3,
    CANCEL: 4,
}
export const PubSubTopic = 'uploadOnProgress'

export const LOGIN_URL = `https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101777919&redirect_uri=${encodeURIComponent(
    `http://open.qq.com/login/callback?from=${window.location.href}`
)}`
